import { toast } from "react-toastify";
import { config } from "../../../core/config/config";
import showToast from "../../../core/utils/showToast";

const base_url = config.baseUrl;
const endpoint = "/contactenos";

async function guardarFormContactenos(formData) {
    try {
        const url = `${base_url + endpoint}`;
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        });

        const result = await response.json();

        if (!response.ok) {
            throw new Error(result.message || 'Error al guardar el formulario');
        }

        if (response.ok) {
            toast.success('Información enviada, nos pondremos en contacto lo mas pronto posible', {
                position: "top-right",
                autoClose: 9000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
            return { success: true, data: result };
        }

    } catch (error) {
        toast.error(error.message || 'Ha ocurrido un error', {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
        });

        return { success: false, message: error.message };
    }
}


export default {
    guardarFormContactenos
};